import { TextareaInput } from '../baseInputs'

type Props = {
  optional?: boolean
  helper?: string
  label?: string
  name?: string
  characterLimit?: number
}

const Comments = ({
  optional,
  helper,
  name,
  characterLimit = 144,
  ...rest
}: Props) => {
  const defaultName = name || 'notes'
  return (
    <TextareaInput
      name={defaultName}
      helper={helper}
      characterLimit={characterLimit}
      optional={optional}
      {...rest}
    />
  )
}

export default Comments
